import * as validators from 'valid.js'
//  Please refer https://github.com/dleitee/valid.js for documentation

let isNil = (value) => !value


validators["validate"]  =
    (...fnArr) =>
        value => {
            let errorObj = {
                isValid:true,
                message:""
              };
            if(!value ){
              value = "";
            }
            return fnArr.reduce((acc, x) => {
                if (isNil(x.fn)) {
                    throw new Error('The function for validation is null or undefined.');
                } else {
                    if(acc.isValid && !x.fn(value)){
                      return {
                        isValid : false,
                        message : x.message || "Validation Failure"
                      }
                    }
                    return acc;
                }
            }, errorObj, fnArr);
    };

export default validators
